module.exports = __webpack_public_path__ + "img/Genesis-Logo-Logo-Transparent.597746d9.png";